const en = {
  // Navbar
  'nav.products': 'Products',
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.services': 'Services',
  'nav.portfolio': 'Portfolio',
  'nav.scenarios': 'Applications',
  'nav.team': 'Team',
  'nav.contact': 'Contact',
  'nav.cta': 'Get In Touch',

  // Hero
  'hero.badge': 'Semiconductor & Panel Display Special Lamp Source Expert',
  'hero.title1': 'The Illuminator of',
  'hero.title2': 'Semiconductors',
  'hero.desc': 'ONOPTO is dedicated to breaking light source technology barriers in high-end manufacturing, delivering ultra-precise, stable and reliable lithography and thermal processing light source solutions to the world\'s leading semiconductor and panel display customers.',
  'hero.btn1': 'Explore Products',
  'hero.btn2': 'View Cases',
  'hero.stat1.value': '3 Series',
  'hero.stat1.label': 'Full Product Coverage',
  'hero.stat2.value': 'R&D',
  'hero.stat2.label': 'Integrated Operations',
  'hero.stat3.value': 'Semi',
  'hero.stat3.label': 'High-End Applications',
  'hero.stat4.value': 'Panel Display',
  'hero.stat4.label': 'Display Industry',
  'hero.scroll': 'Scroll',

  // About
  'about.badge': 'About Us',
  'about.overlay.title': 'Industry Quality Certified',
  'about.overlay.sub': 'Semiconductor & Panel Standard',
  'about.accent.label': 'Core Special Lamp Series',
  'about.title1': 'Specialized in',
  'about.title2': 'Every Lamp, Crafted with Care',
  'about.desc1': 'Since 2024, ONOPTO has formally served the semiconductor and panel display industries, offering a full range of high-pressure mercury lamps, halogen heating lamps, and UV lamps. Our light sources are precisely applied to lithography exposure, thermal annealing, and panel adhesive curing — renowned for high stability, high energy density, and long service life.',
  'about.desc2': 'Dedicated to domestic substitution through self-developed technology, becoming a trusted light source partner in semiconductor and display panel manufacturing. Over 60% of our team members are seasoned professionals from the semiconductor and panel display industry, with careers spanning the complete supply chain — from upstream material development and midstream process engineering to downstream equipment manufacturing.',
  'about.m1.label': 'R&D Driven',
  'about.m1.value': 'Integrated R&D, Mfg & Sales',
  'about.m2.label': 'Semiconductor',
  'about.m2.value': 'Lithography / Thermal / Epitaxy',
  'about.m3.label': 'Panel Display',
  'about.m3.value': 'Alignment / Curing / Large-Area Expo',
  'about.m4.label': 'Inspection Equipment',
  'about.m4.value': 'High-Performance Xenon Lamps',
  'about.btn': 'Contact Us for More',

  // Services
  'services.badge': 'Our Products',
  'services.title1': 'Core Products',
  'services.title2': 'Four Series',
  'services.desc': 'Covering the full semiconductor lithography, thermal processing, inspection, and panel display process chain — providing reliable special lamp source support for high-end manufacturing.',
  'services.s1.title': 'Lithography High-Pressure Mercury Lamps',
  'services.s1.titleEn': 'Lithography High-Pressure Mercury Lamps',
  'services.s1.desc': 'High-pressure mercury lamps designed specifically for lithography machines, with extremely high UV output intensity and stability, ensuring precise exposure in lithography processes to meet the stringent requirements of semiconductor manufacturing for micro and nano-scale patterning.',
  'services.s1.f1': 'High UV Output Intensity',
  'services.s1.f2': 'Long-Life Stable Discharge',
  'services.s1.f3': 'Strict Consistency Control',
  'services.s2.title': 'Detection Equipment Xenon Lamps',
  'services.s2.titleEn': 'Detection Equipment Xenon Lamps',
  'services.s2.desc': 'High-performance xenon lamps for semiconductor and panel inspection equipment, providing broad-spectrum, high-brightness, highly stable light source output to ensure precise identification of micro-defects in optical inspection systems.',
  'services.s2.f1': 'Broad-Spectrum Continuous Output',
  'services.s2.f2': 'High-Brightness Stable Emission',
  'services.s2.f3': 'Fast Start-Up Response',
  'services.s3.title': 'Semiconductor RTP & EPI Heating Lamps',
  'services.s3.titleEn': 'Semiconductor RTP & EPI Heating Lamps',
  'services.s3.desc': 'High-power halogen heating lamps for semiconductor rapid thermal processing (RTP) and epitaxial growth (EPI) equipment, ensuring uniform temperature distribution, rapid thermal response, and stable process reliability during wafer thermal treatment.',
  'services.s3.f1': 'High-Power Uniform Heating',
  'services.s3.f2': 'Fast Thermal Response',
  'services.s3.f3': 'Long-Life High-Temp Design',
  'services.s4.title': 'Panel Alignment & Curing Lamps',
  'services.s4.titleEn': 'Panel Alignment & Curing Lamps',
  'services.s4.desc': 'UV alignment exposure lamps and UV curing lamps designed for the panel display industry, providing precise wavelength UV output to meet the high-efficiency and stable requirements of liquid crystal alignment treatment and photocuring processes.',
  'services.s4.f1': 'Precise UV Wavelength Output',
  'services.s4.f2': 'High Uniformity Illumination',
  'services.s4.f3': 'Compatible with Multiple Panel Processes',

  // Portfolio
  'portfolio.badge': 'Portfolio',
  'portfolio.title1': 'Application Cases',
  'portfolio.title2': 'Industry Coverage',
  'portfolio.desc': 'Real-world special lamp source application cases covering the full process chain of semiconductor and panel display industries.',
  'portfolio.cat.all': 'All',
  'portfolio.cat.litho': 'Lithography',
  'portfolio.cat.xenon': 'Detection',
  'portfolio.cat.rtp': 'RTP/EPI',
  'portfolio.cat.align': 'Alignment',
  'portfolio.cat.cure': 'Curing',
  'portfolio.p1.category': 'Semiconductor Lithography',
  'portfolio.p1.title': 'Mainstream Lithography Mercury Lamp Replacement',
  'portfolio.p1.desc': 'Supplied stable lithography high-pressure mercury lamps to a leading domestic semiconductor manufacturer, achieving import substitution, effectively reducing procurement costs, with product consistency and lifetime reaching international equivalents.',
  'portfolio.p1.tag': 'Lithography',
  'portfolio.p2.category': 'Semiconductor Inspection',
  'portfolio.p2.title': 'Wafer Defect Detection Xenon Lamp Upgrade',
  'portfolio.p2.desc': 'Customized high-brightness xenon lamp modules for a semiconductor inspection equipment manufacturer, improving wafer surface micro-defect detection rate, effectively supporting yield control needs, with stable operation exceeding 5,000 hours.',
  'portfolio.p2.tag': 'Detection',
  'portfolio.p3.category': 'RTP Rapid Annealing',
  'portfolio.p3.title': 'RTP Rapid Annealing Equipment Lamp Supply',
  'portfolio.p3.desc': 'Specialized halogen heating lamps for RTP rapid thermal processing equipment, meeting the needs of wafer high-temperature uniform annealing, with stable high-temperature performance and excellent batch consistency.',
  'portfolio.p3.tag': 'Thermal',
  'portfolio.p4.category': 'Panel Alignment',
  'portfolio.p4.title': 'LCD Panel UV Alignment Exposure Lamp Application',
  'portfolio.p4.desc': 'Provided UV alignment lamp solutions for large-size LCD panel production lines, ensuring uniformity and stability of liquid crystal molecular alignment treatment, supporting efficient mass production requirements of high-generation panel lines.',
  'portfolio.p4.tag': 'Alignment',
  'portfolio.p5.category': 'Panel Curing',
  'portfolio.p5.title': 'OLED Packaging UV Curing Lamp System',
  'portfolio.p5.desc': 'Provided high-power UV curing lamps for OLED panel packaging production lines, precisely outputting specific wavelength UV light, meeting fast curing process requirements for encapsulants, helping improve panel yield and throughput.',
  'portfolio.p5.tag': 'Curing',
  'portfolio.p6.category': 'EPI Epitaxial Growth',
  'portfolio.p6.title': 'EPI Epitaxial Growth Lamp Configuration',
  'portfolio.p6.desc': 'Supplied specialized heating lamp arrays for compound semiconductor epitaxial growth equipment, meeting stringent requirements of MOCVD and other processes for uniform heating, high-temperature stability, and lamp lifetime, ensuring epitaxial wafer quality consistency.',
  'portfolio.p6.tag': 'RTP/EPI',

  // Team
  'team.badge': 'Our Team',
  'team.title1': 'Expert Team',
  'team.title2': 'Driving Innovation',
  'team.desc': 'The ONOPTO team brings together professionals in optical engineering, semiconductor processes, panel display, and business operations, collectively advancing breakthroughs in special lamp source technology and applications.',
  'team.t1.title': 'Founder & General Manager',
  'team.t1.bio': 'B.S. in Mechanical Automation, Tongji University. Co-founder of ONOPTO. Leads company strategy and overall operations, leveraging extensive industry resources and deep domain expertise to build ONOPTO\'s integrated R&D, manufacturing, and sales system from the ground up, driving the company\'s professional growth in semiconductor and panel display markets.',
  'team.t2.title': 'Mercury Lamp R&D Director',
  'team.t2.bio': 'B.S. in Mechanical Engineering, Zhejiang University. Former Back-End Packaging & Testing Manager at Shanghai Huahong NEC and VP of High-Vacuum Systems Technology at Poisson Semiconductor Applied Materials. Deep expertise in semiconductor manufacturing and high-vacuum systems. Leads mercury lamp series R&D at ONOPTO, driving performance improvements and process innovation to support product iteration, quality control, and industrialization.',
  'team.t3.title': 'Heating Lamp R&D Director',
  'team.t3.bio': 'M.S. in Mechanical Automation, Shanghai University. Former engineer at Shanghai Huahong NEC and Autoliv Sweden. Extensive expertise in precision manufacturing and optoelectronic technology, with hands-on experience in semiconductor equipment engineering and electrical control system R&D. Specializes in structural design and performance optimization of optical components under high-reliability and extreme-condition requirements, with a focus on improving thermal efficiency and environmental adaptability of heating lamps.',
  'team.t4.title': 'UV Lamp R&D & Quality Director',
  'team.t4.bio': 'M.S. in Physics, Beijing University of Technology. Former Inspection Manager at AVIC Optoelectronics and Optical Yield Manager at HOE. Deep expertise in optical inspection, quality control, and UV lamp core technology R&D and full-process quality management.',
  'team.t5.title': 'Co-Founder & Deputy GM',
  'team.t5.bio': 'B.S. in Mechanical Automation, Shanghai Institute of Technology. Co-founder of ONOPTO. Oversees financial management and internal operations, playing a key role in capital planning, cost control, and operational compliance to support the company\'s stable and sustainable growth.',
  'team.t6.title': 'Shareholder & Sales Director',
  'team.t6.bio': 'B.S. in Mechanical Engineering, Hanyang University (South Korea). Shareholder of ONOPTO. Leads sales operations with a deep understanding of semiconductor and panel display customer needs, driving continuous expansion of the company\'s client network and revenue growth through extensive market development experience.',
  'team.cta.title': 'Join Our Team',
  'team.cta.desc': 'We are continuously seeking professionals passionate about semiconductor light sources, optical engineering, and high-end manufacturing to explore the infinite possibilities of special lamp source technology together.',
  'team.cta.btn': 'View Open Positions',

  // Contact
  'contact.badge': 'Contact Us',
  'contact.title1': '',
  'contact.title2': '',
  'contact.desc': 'Have product requirements, technical inquiries, or partnership interests? Leave your information and the ONOPTO team will contact you within 24 hours.',
  'contact.info1.label': 'Email',
  'contact.info1.value': 'info@onopto.com',
  'contact.info2.label': 'Business Hours',
  'contact.info2.value': 'Mon–Fri  09:00 – 18:00',
  'contact.info3.label': 'Business Inquiry',
  'contact.info3.value': 'Welcome inquiries about product selection and custom requirements',
  'contact.form.name': 'Full Name',
  'contact.form.namePh': 'Your Name',
  'contact.form.email': 'Email',
  'contact.form.emailPh': 'your@company.com',
  'contact.form.company': 'Company',
  'contact.form.companyPh': 'Your Company',
  'contact.form.service': 'Product Interest',
  'contact.form.servicePh': 'Select a Product',
  'contact.form.message': 'Message',
  'contact.form.messagePh': 'Describe your product requirements, equipment model, or partnership interest...',
  'contact.form.required': '*',
  'contact.form.submit': 'Send Message',
  'contact.form.submitting': 'Sending...',
  'contact.form.charCount': '{{count}}/500',
  'contact.form.err.required': 'Please fill in all required fields.',
  'contact.form.err.tooLong': 'Message cannot exceed 500 characters.',
  'contact.form.err.failed': 'Submission failed. Please try again.',
  'contact.form.err.network': 'Network error. Please try again.',
  'contact.success.title': 'Message Sent!',
  'contact.success.desc': 'Thank you for contacting ONOPTO. Our team will reach out within 24 business hours.',
  'contact.opt.litho': 'Lithography High-Pressure Mercury Lamps',
  'contact.opt.xenon': 'Detection Equipment Xenon Lamps',
  'contact.opt.rtp': 'Semiconductor RTP Heating Lamps',
  'contact.opt.epi': 'Semiconductor EPI Heating Lamps',
  'contact.opt.align': 'Panel Alignment Lamps',
  'contact.opt.cure': 'Panel Curing Lamps',
  'contact.opt.other': 'Other',

  // Footer
  'footer.brand.desc': 'ONOPTO — specializing in semiconductor and panel high-end special light sources, integrating R&D, manufacturing, and sales to provide reliable lamp source support for high-end manufacturing.',
  'footer.s1.title': 'Products',
  'footer.s2.title': 'Company',
  'footer.s3.title': 'Applications',
  'footer.s4.title': 'Contact',
  'footer.s1.l1': 'Lithography Mercury Lamps',
  'footer.s1.l2': 'Detection Xenon Lamps',
  'footer.s1.l3': 'Semiconductor RTP Lamps',
  'footer.s1.l4': 'Semiconductor EPI Lamps',
  'footer.s1.l5': 'Panel Alignment & Curing Lamps',
  'footer.s2.l1': 'About Us',
  'footer.s2.l2': 'Our Team',
  'footer.s2.l3': 'Careers',
  'footer.s2.l4': 'Case Studies',
  'footer.s2.l5': 'Partners',
  'footer.s3.l1': 'Semiconductor Lithography',
  'footer.s3.l2': 'Thermal Processing Equipment',
  'footer.s3.l3': 'Wafer Optical Inspection',
  'footer.s3.l4': 'LCD Panel Alignment',
  'footer.s3.l5': 'OLED Encapsulation Curing',
  'footer.s4.l1': 'info@onopto.com',
  'footer.s4.l2': 'Product Inquiry',
  'footer.s4.l3': 'Custom Requirements',
  'footer.s4.l4': 'Technical Support',
  'footer.s4.l5': 'Business Cooperation',
  'footer.wechat.label': 'WeChat Official',
  'footer.wechat.sub': 'Scan to Follow ONOPTO',
  'footer.bottom.copyright': '© {{year}} ONOPTO 普像光学. All Rights Reserved.',
  'footer.bottom.privacy': 'Privacy Policy',
  'footer.bottom.terms': 'Terms of Use',
  'footer.bottom.contact': 'Contact Us',

  // Table Headers
  'table.image': 'Image',
  'table.onopto_model': 'ONOPTO Model',
  'table.oem_model': 'OEM Model',
  'table.power': 'Rated Power',
  'table.current': 'Rated Current',
  'table.voltage': 'Rated Voltage',
  'table.note': 'Remarks',
  'table.equipment': 'Equipment',
  'table.color_temp': 'Color Temp',
  'table.length': 'Length',
  'table.name': 'Product Name',
  'table.spec': 'Specifications',
  'table.custom': 'For custom specifications, please contact us.',

  // Products Page
  'products.badge': 'Special Light Source Product Center',
  'products.hero.title1': 'Three Series',
  'products.hero.title2': 'Endless Light',
  'products.hero.desc': 'ONOPTO\'s three core product series — Mercury Lamps, Heating Lamps, and UV Lamps — deliver high-performance special light source solutions for every critical semiconductor and panel display process.',
  'products.mascot.label': 'Series Mascot Gallery',
  'products.series.mercury.name': 'Mercury Lamp Series',
  'products.series.mercury.desc': 'High-pressure mercury lamps engineered for semiconductor lithography equipment. Delivering extreme UV output stability and long operational lifetime, supporting i-line, g-line, h-line and various lithography process nodes.',
  'products.series.mercury.p1.model': 'ONM-365',
  'products.series.mercury.p1.name': 'i-line 365nm High-Pressure Mercury Lamp',
  'products.series.mercury.p1.spec': '365nm | 1000W–5000W | Life ≥1500h',
  'products.series.mercury.p1.app': 'Suitable for i-line lithography exposure systems of mainstream semiconductor equipment',
  'products.series.mercury.p2.model': 'ONM-436',
  'products.series.mercury.p2.name': 'g-line 436nm High-Pressure Mercury Lamp',
  'products.series.mercury.p2.spec': '436nm | 500W–2000W | Life ≥2000h',
  'products.series.mercury.p2.app': 'Applied to g-line lithography processes of PCB and semiconductor back-end packaging equipment',
  'products.series.mercury.p3.model': 'ONM-405',
  'products.series.mercury.p3.name': 'h-line 405nm High-Pressure Mercury Lamp',
  'products.series.mercury.p3.spec': '405nm | 500W–3000W | Life ≥2000h',
  'products.series.mercury.p3.app': 'For h-line lithography systems with high uniformity and stability requirements',
  'products.series.mercury.p4.model': 'ONM-UHP',
  'products.series.mercury.p4.name': 'UHP Ultra High-Pressure Mercury Lamp',
  'products.series.mercury.p4.spec': 'Broadband UV | 200W–1000W | High Brightness',
  'products.series.mercury.p4.app': 'Used in UV exposure inspection and high-brightness optical systems',
  'products.series.heating.name': 'Heating Lamp Series',
  'products.series.heating.desc': 'High-power halogen tungsten heating lamps for semiconductor RTP rapid thermal processing and EPI epitaxial growth equipment. Ensuring uniform temperature distribution, fast thermal response, and reliable high-temperature stability across every wafer.',
  'products.series.heating.p1.model': 'ONH-RTP',
  'products.series.heating.p1.name': 'RTP Single-Tube Halogen Heating Lamp',
  'products.series.heating.p1.spec': '1000W–3000W/tube | Tmax ≥1200°C',
  'products.series.heating.p1.app': 'Suitable for wafer rapid thermal annealing, oxidation, and nitridation processes',
  'products.series.heating.p2.model': 'ONH-EPI',
  'products.series.heating.p2.name': 'EPI Ring Heating Lamp Array',
  'products.series.heating.p2.spec': 'Multi-zone control | High temp uniformity ≤±1%',
  'products.series.heating.p2.app': 'For compound semiconductor and silicon epitaxial growth equipment such as MOCVD',
  'products.series.heating.p3.model': 'ONH-MZ',
  'products.series.heating.p3.name': 'Multi-Zone Heating Lamp Module',
  'products.series.heating.p3.spec': '3–12 zone | Custom power configuration',
  'products.series.heating.p3.app': 'High-precision multi-zone temperature control for advanced thermal processing equipment',
  'products.series.heating.p4.model': 'ONH-LN',
  'products.series.heating.p4.name': 'Linear Array Heating Lamp',
  'products.series.heating.p4.spec': 'Linear type | Fast response | Long lifetime',
  'products.series.heating.p4.app': 'Used in belt furnace and continuous thermal processing production lines',
  'products.series.uv.name': 'UV Lamp Series',
  'products.series.uv.desc': 'Precision UV light sources for the panel display industry — alignment and curing lamps providing accurate wavelength output and high-uniformity illumination for every panel process.',
  'products.series.uv.p1.model': 'ONU-ALN',
  'products.series.uv.p1.name': 'LCD UV Alignment Exposure Lamp',
  'products.series.uv.p1.spec': '254nm / 313nm | High uniformity | Long lifetime',
  'products.series.uv.p1.app': 'Liquid crystal molecular alignment treatment for TFT-LCD panel production lines',
  'products.series.uv.p2.model': 'ONU-CUR',
  'products.series.uv.p2.name': 'UV Curing Lamp',
  'products.series.uv.p2.spec': '300–400nm | High power density | Rapid cure',
  'products.series.uv.p2.app': 'OLED encapsulation and sealant curing in panel display processes',
  'products.series.uv.p3.model': 'ONU-XEN',
  'products.series.uv.p3.name': 'Inspection Xenon Lamp',
  'products.series.uv.p3.spec': 'Broadband | High brightness | Long life ≥5000h',
  'products.series.uv.p3.app': 'Semiconductor wafer surface defect detection and optical inspection equipment',
  'products.series.uv.p4.model': 'ONU-DEP',
  'products.series.uv.p4.name': 'Deep UV Curing Lamp',
  'products.series.uv.p4.spec': '185nm–254nm | Deep UV output',
  'products.series.uv.p4.app': 'Advanced substrate surface treatment and deep UV photolithography processes',
  'products.hero.explore': 'Explore Three Series',
  'products.cta.title': 'Need a Custom Solution?',
  'products.cta.desc': 'Our engineering team provides customized special lamp source solutions tailored to your equipment model and process requirements. Contact us for product selection, sample testing, or volume procurement.',
  'products.cta.btn1': 'Contact Us',
  'products.cta.btn2': 'Back to Home',
};

export default en;
